import { render, staticRenderFns } from "./ProjektStarten.vue?vue&type=template&id=6cf83d67&scoped=true&"
import script from "./ProjektStarten.vue?vue&type=script&lang=js&"
export * from "./ProjektStarten.vue?vue&type=script&lang=js&"
import style0 from "./ProjektStarten.vue?vue&type=style&index=0&id=6cf83d67&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf83d67",
  null
  
)

export default component.exports